import { serverAxios } from '@/shared/api';

interface ArticleDetailHighlightApiParams {
  newsId: number;
}

export interface ArticleDetailHighlightResponseItem {
  id: number;
  block_position: number;
  selected_length: number;
  text: string;
  text_position: number;
  text_position_absolute: number;
  memo: string;
}

export const articleDetailHighlightApi = ({
  newsId,
}: ArticleDetailHighlightApiParams) => {
  return serverAxios.get<ArticleDetailHighlightResponseItem[]>(
    `/yozmit/news/${newsId}/highlights/`
  );
};

export interface DeleteHighlightApiParams {
  highlightId: string;
}

export const deleteHighlightApi = ({
  highlightId,
}: DeleteHighlightApiParams) => {
  return serverAxios.delete(`/yozmit/highlights/${highlightId}/`);
};

export interface AddArticleDetailHighlightApiParams {
  newsId: number | string;
  profileId: number | string;
  selectedString: string;
  blockPosition: number;
  textPosition: number;
  selectedLength: number;
  memo?: string;
}

export interface ArticleDetailNewHighlightResponseItem {
  id: number;
  profile_id: number;
  news_id: number;
  block_position: number;
  selected_length: number;
  text_position_absolute: number;
  memo: string;
}

export const addArticleDetailHighlightApi = ({
  newsId,
  ...body
}: AddArticleDetailHighlightApiParams) => {
  const {
    profileId,
    selectedLength,
    blockPosition,
    textPosition,
    selectedString,
    memo,
  } = body;
  return serverAxios.post<ArticleDetailNewHighlightResponseItem>(
    `/yozmit/news/${newsId}/highlights/`,
    {
      profile_id: profileId,
      selected_string: selectedString,
      block_position: blockPosition,
      selected_length: selectedLength,
      text_position: textPosition,
      text_position_absolute: textPosition,
      memo,
    }
  );
};

export interface PatchArticleDetailHighlightApiParams {
  highlightId: number | string;
  profileId: number | string;
  selectedString?: string;
  blockPosition?: number;
  textPosition?: number;
  selectedLength?: number;
  memo?: string;
}

export const patchArticleDetailHighlightApi = ({
  highlightId,
  ...body
}: PatchArticleDetailHighlightApiParams) => {
  const {
    profileId,
    selectedLength,
    blockPosition,
    textPosition,
    selectedString,
    memo,
  } = body;
  return serverAxios.patch<ArticleDetailNewHighlightResponseItem>(
    `/yozmit/highlights/${highlightId}/`,
    {
      profile_id: profileId,
      selected_string: selectedString,
      block_position: blockPosition,
      selected_length: selectedLength,
      text_position: textPosition,
      text_position_absolute: textPosition,
      memo,
    }
  );
};

interface MostHighlightedText {
  text: string;
  news: {
    id: number;
    title: string;
  };
}
type MostHighlightedTextApiResponse = MostHighlightedText[];

export const mostHighlightedTextApi = () => {
  return serverAxios.get<MostHighlightedTextApiResponse>(
    '/yozmit/most-highlight-text/'
  );
};
